/* eslint-disable react/jsx-key */
// import React from 'react';
// import { SideNavBar } from 'fibe-ui';

/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';

import {
  useAuthStore,
  useAutoDebitStore,
  useDashboardStore,
  useUIControlsStore,
} from '../../../redux/index';

import { APPLICATION_PROCESS_ROUTES } from '../../../utils/constants/index';

import FibeIcon from '../../../assets/side-nav/Fibe_Icon.svg';
import FibeLogo from '../../../assets/side-nav/Fibe_Logo.svg';
import LearnIcon from '../../../assets/learn.svg';
import FAQIcon from '../../../assets/help.svg';
import LogoutIcon from '../../../assets/logout.svg';
import MoneyBagIcon from '../../../assets/money-bag.svg';
import LoanStatementIcon from '../../../assets/loan-statement.svg';
import RightArrowIcon from '../../../assets/rightArrow.svg';
import EditProfileIcon from '../../../assets/edit-profile.svg';
import AboutUsIcon from '../../../assets/aboutusicon.svg';

import ProfileLogo from '../../../assets/side-nav/profileIcon.svg';
import DashboardLogo from '../../../assets/side-nav/dashboardIcon2.svg';
import SettingsIcon from '../../../assets/auto-debit/settings-icon-nach-cancel.png';
import SettingsIcon2 from '../../../assets/auto-debit/settingIconNew.svg';

import Fibo from '../../../assets/side-nav/Fibo.svg';
import crossIcon from '../../../assets/crossIcon1.svg';
import { SecureClient } from '../../../utils';

function SideNav({
  tabs,
  isDemo = false,
  variant,
  width,
  height,
  showsidebar,
  logoutClickHandler,
  pullChildDataFnc,
  isClicked,
  setClicked,
  otherTabs,
}) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { completeProfileRoute, customerId, customerRefNum, Authorization } =
    useAuthStore();

  const [isSettingClicked, setIsSettingClicked] = useState(false);

  const [
    isEligibleForSmartRepayCancellation,
    setIsEligibleForSmartRepayCancellation,
  ] = useState(false);

  const clickAwayHandler = (e) => {
    try {
      const htmlElement = e.target;
      if (htmlElement.className.includes('passive-click-detector')) {
        showsidebar();
      }
    } catch (err) {
      console.log(err);
    }
  };
  const logoutClicked = () => {
    logoutClickHandler && logoutClickHandler();
    setClicked((isClicked) => !isClicked);
    pullChildDataFnc(false);
  };
  const clickHandler = (item) => {
    if (item.tabLabel === 'Setting') {
      setIsSettingClicked((prev) => !prev);
      return;
    }
    if (item.tabLabel === 'Logout') {
      logoutClicked();
    } else {
      navigate(item.path, {
        state: {
          url:
            item.tabLabel === 'Learn'
              ? `https://portal-ec2.fibe.in/learn?src=mobile`
              : ``,
        },
      });
      showsidebar();
    }
  };

  const getNachStatusAPICallLocal = () => {
    SecureClient({
      isEncrypted: true,
      customerId: customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerkyc/getnachstatus',
      headers: {
        Authorization,
      },
      payload: {
        customerRefNum,
      },
      successFn: (res) => {
        console.log('getNachStatusAPiI success', res);
        const { body, statusCode, statusMsg, statusDes } = res;
        const { autopaymentResponse } = body;
        const { isEligibleForEmandateCancellation } = autopaymentResponse;
        if (statusCode === 200) {
          setIsEligibleForSmartRepayCancellation(
            isEligibleForEmandateCancellation
          );
        }
      },
      errorFn: (err) => {
        console.log('getNachStatusAPiI error', err);
      },
      finallyFn: () => {
        console.log('Finally');
      },
    });
  };

  useEffect(() => {
    // getNachStatusAPICallLocal();
  }, []);

  const handleCrossIconClicked = () => {
    setIsSettingClicked(false);
    showsidebar();
  };

  const shouldDisplayTabItems = (tabItem) => {
    const { tabLabel } = tabItem;
    switch (tabLabel) {
      case 'Setting':
        return isEligibleForSmartRepayCancellation ? true : false;
      default:
        return true;
    }
  };

  return (
    <>
      <div className="h-full passive-click-detector" onClick={clickAwayHandler}>
        {variant === 'sideNav' && (
          <div
            className={`relative pt-7 bg-white lg:float-none float-right z-[auto] lg:z-[-1]  ${
              isDemo ? 'w-64' : width
            } rounded-l-[31px] transition-all lg:rounded-tl-[0] lg:rounded-tr-[31px] [box-shadow:0px_-20px_26px_rgba(0,0,0,0.12)] h-full lg:h-screen`}
          >
            <div className="absolute right-5 top-10 block lg:hidden cursor-pointer">
              <img
                id="menuCrossIcon"
                src={crossIcon}
                alt="crossIcon1"
                onClick={handleCrossIconClicked}
              />
            </div>
            <div className="pl-7 flex flex-col gap-2 pb-[1rem] lg:pb-[2.75rem] cursor-pointer w-24 lg:w-auto">
              <img
                id="fibeLogo"
                src={FibeIcon}
                alt="Greater Symbol representing Fibe"
                className="w-7 h-7"
              />
              <img
                id="fibeLogo1"
                src={FibeLogo}
                alt="Fibe logo"
                className="h-10 w-24 secondary:h-8 secondary:w-20"
              />
            </div>
            <div
              className={`flex flex-col justify-between cursor-pointer overflow-auto pb-14 lg:pb-0`}
            >
              <div className="pb-10 mobile-zoom h-screen md:h-auto overflow-auto">
                {tabs.map((item, idx) => (
                  <>
                    {shouldDisplayTabItems(item) ? (
                      <>
                        <div
                          id={`compProfile-${idx}`}
                          key={item.tabLabel}
                          className={`pl-7 flex items-center relative text-base font-semibold leading-6 cursor-pointer lg:mb-2 secondary:py-3 py-4 hover:bg-background-accentLight hover:pl-7 secondary:hover:py-3 hover:py-4 hover:text-accent transition duration-200 ease-in-out ${
                            item.tabLabel === 'Setting' && isSettingClicked
                              ? 'text-accent bg-background-accentLight pl-7 secondary:py-3 py-4 border-l-[6px] border-solid border-accent'
                              : 'text-text-dark bg-inherit'
                          } ${item.onlyMobile ? 'lg:hidden' : ''}`}
                          onClick={() => clickHandler(item)}
                          role="link"
                          tabIndex={0}
                        >
                          <img
                            src={item.logo}
                            alt={item.altText}
                            className="w-5 hover:fill-accent mr-3"
                          />
                          <p className="hover:text-accent">{item.tabLabel}</p>
                        </div>

                        {item.child?.map((childItem) => (
                          <Link to={childItem.path}>
                            <div
                              className={`text-[#999999] pl-10 text-base font-normal mt-2 ${
                                item.onlyMobile ? 'lg:hidden' : ''
                              } ${!isSettingClicked ? 'hidden' : null} `}
                            >
                              {childItem.tablLabelName}
                            </div>
                          </Link>
                        ))}
                      </>
                    ) : null}
                  </>
                ))}
              </div>
              <div className="pl-7"></div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default function SideNavComp(props) {
  const {
    showsidebar,
    logoutClickHandler,
    pullChildDataFnc,
    isClicked,
    setClicked,
  } = props;
  const { completeProfileRoute } = useUIControlsStore();
  const { fibeCardActionTypes } = useDashboardStore();
  const { authState } = useAuthStore();
  const { hideDashboardTabOnSidenav } = authState;
  const defaultTabs = [
    {
      tabLabel: 'Dashboard',
      logo: DashboardLogo,
      altText: 'Dashboard',
      routeTo: ['/dashboard'],
      path: '/dashboard',
      onlyMobile: false,
    },
    {
      tabLabel: 'Fibo',
      logo: Fibo,
      altText: 'Fibo',
      routeTo: ['/fibo'],
      path: '/fibo',
      onlyMobile: false,
    },
    {
      tabLabel: 'Loan statement',
      logo: LoanStatementIcon,
      altText: 'Loan statement',
      routeTo: ['/loan-statement'],
      path: '/loan-statement',
      onlyMobile: true,
    },
    // {
    //   tabLabel: 'Learn',
    //   logo: LearnIcon,
    //   altText: 'Learn',
    //   routeTo: ['/learn'],
    //   path: '/learn',
    //   onlyMobile: true,
    // },
    // {
    //   tabLabel: 'Upgrade your limit',
    //   logo: MoneyBagIcon,
    //   altText: 'Upgrade your limit',
    //   routeTo: ['/upgrade-your-limit'],
    //   path: '/upgrade-your-limit',
    //   onlyMobile: true,
    // },
    // {
    //   tabLabel: 'FAQs',
    //   logo: FAQIcon,
    //   altText: 'FAQs',
    //   routeTo: ['/faq'],
    //   path: '/faq',
    //   onlyMobile: true,
    // },
    // DOCS: Commenting edit profile for phase1
    // {
    //   tabLabel: 'Edit profile',
    //   logo: EditProfileIcon,
    //   altText: 'Edit profile',
    //   routeTo: ['/edit-profile'],
    //   path: '/edit-profile',
    //   onlyMobile: true,
    // },
    // {
    //   tabLabel: 'About us',
    //   logo: AboutUsIcon,
    //   altText: 'About us',
    //   routeTo: ['/about-us'],
    //   path: '/about-us',
    //   onlyMobile: true,
    // },
    {
      tabLabel: 'Setting',
      logo: SettingsIcon2,
      altText: 'Setting',
      routeTo: '',
      path: '',
      onlyMobile: true,
      child: [
        {
          tablLabelName: 'Cancel Auto Debit',
          path: '/nach-cancellation/start',
        },
      ],
    },
    {
      tabLabel: 'Logout',
      logo: LogoutIcon,
      altText: 'Logout',
      routeTo: '',
      path: '',
      onlyMobile: true,
    },
  ];

  const [sideNavTabsToShow, setSideNavTabsToShow] = useState([...defaultTabs]);

  // console.log('completeProfileRoute: ', completeProfileRoute, APPLICATION_PROCESS_ROUTES.includes(completeProfileRoute));
  // console.log('fibeCardActionTypes: ', fibeCardActionTypes);

  const otherTabs = [
    {
      tabLabel: 'Settings',
      logo: SettingsIcon,
      altText: 'Settings',
      routeTo: '',
      path: '',
      onlyMobile: false,
      child: [
        {
          tablLabelName: 'Cancel Auto Debit',
          path: '/nach-cancellation/start',
        },
      ],
    },
  ];

  useEffect(() => {
    const completeProfileTab = {
      tabLabel: 'Complete Profile',
      logo: ProfileLogo,
      altText: 'Complete Profile',
      routeTo: [
        '/application-process',
        '/bank-statement',
        '/kyc-process',
        '/pre-pan',
        '/post-pan',
        '/itr-journey',
        '/auto-debit',
        '/lo-hold',
        '/suspend-landing',
        '/suspend',
        '/first-jobber-landing',
        '/first-jobber',
      ],
      path: `${completeProfileRoute}`,
    };
    // DOCS: Adds complete profile route dynamically only for onboarding customers
    if (APPLICATION_PROCESS_ROUTES?.includes(completeProfileRoute)) {
      setSideNavTabsToShow([completeProfileTab, ...defaultTabs]);
    } else {
      setSideNavTabsToShow([...defaultTabs]);
    }
  }, [completeProfileRoute]);
  useEffect(() => {
    if (hideDashboardTabOnSidenav) {
      setSideNavTabsToShow([
        {
          tabLabel: 'Fibo',
          logo: Fibo,
          altText: 'Fibo',
          routeTo: ['/fibo'],
          path: '/fibo',
        },
      ]);
    }
  }, [hideDashboardTabOnSidenav]);

  return (
    <SideNav
      variant="sideNav"
      logoutClickHandler={logoutClickHandler}
      pullChildDataFnc={pullChildDataFnc}
      isClicked={isClicked}
      setClicked={setClicked}
      tabs={sideNavTabsToShow}
      otherTabs={otherTabs}
      width="w-64 xxxl:w-[17rem]"
      height="h-full"
      // height="h-[82vh]"
      showsidebar={showsidebar}
    />
  );
}
